import Filter from './moment.js'

function formatDate (cellValue) {
  if (cellValue) {
    let str = String(cellValue)
    let time = cellValue
    if (str.length === 10) {
      time = cellValue * 1000
    }
    return Filter.formatDate(new Date(time), 'yyyy-MM-dd')
  } else {
    return '/'
  }
}
function formatDateTime (cellValue) {
  if (cellValue) {
    let str = String(cellValue)
    let time = cellValue
    if (str.length === 10) {
      time = cellValue * 1000
    }
    return Filter.formatDate(new Date(time), 'yyyy-MM-dd hh:mm:ss')
  } else {
    return '/'
  }
}
function formatSex (cellValue) {
  if (cellValue === 'UNKNOWN') {
    return '保密'
  }
  if (cellValue === 'MALE') {
    return '男'
  } else if (cellValue === 'FEMALE') {
    return '女'
  }
  return cellValue
}
function formatIsOnline (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'YES') {
    return '上线'
  } else if (cellValue === 'NO') {
    return '下线'
  }
  return cellValue
}
function formatAccountType (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'CONSUME') {
    return '消费'
  } else if (cellValue === 'RECHARGE') {
    return '充值'
  }
  return cellValue
}
function formatIntegralType (cellValue) {
  if (cellValue === 'CANCEL_RETURN') {
    return '取消返回'
  } else if (cellValue === 'SIGNIN') {
    return '签到赠送'
  } else if (cellValue === 'DATA_SYNC') {
    return '数据同步'
  } else if (cellValue === 'MANUAL_MODIFY') {
    return '人工修改'
  } else if (cellValue === 'ORDER_REBATE') {
    return '下单返利'
  } else if (cellValue === 'REGISTER_GIVE') {
    return '注册赠送'
  } else if (cellValue === 'ORDER_DEDUCT') {
    return '使用扣除'
  }
  return cellValue
}
function formatOnlineText (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'YES') {
    return '下线'
  } else if (cellValue === 'NO') {
    return '上线'
  }
  return cellValue
}
function formatOnlineIcon (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'YES') {
    return 'iconfont icon-xiaxian'
  } else if (cellValue === 'NO') {
    return 'iconfont icon-shangxian'
  }
  return cellValue
}
function formatIsTop (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'YES') {
    return '已置顶'
  } else if (cellValue === 'NO') {
    return '未置顶'
  }
  return cellValue
}
function formatTopText (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'YES') {
    return '取消置顶'
  } else if (cellValue === 'NO') {
    return '置顶'
  }
  return cellValue
}
function formatStartText (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'YES') {
    return '停用'
  } else if (cellValue === 'NO') {
    return '启用'
  }
  return cellValue
}
function formatStartIcon (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'YES') {
    return 'iconfont icon-tingyongicon'
  } else if (cellValue === 'NO') {
    return 'iconfont icon-qiyongicon'
  }
  return cellValue
}
function formatChangeStatus (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'YES') {
    return 'NO'
  } else if (cellValue === 'NO') {
    return 'YES'
  }
  return cellValue
}
function formatPriceType (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'CASH') {
    return '现金'
  } else if (cellValue === 'POINT') {
    return '积分'
  }
  return cellValue
}
function formatChangeDateAndriodIos (cellValue) {
  let arr = cellValue.replace(/(\-)/g, '/')
  const date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5])
  return date
}
function formatBuyType (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'ROUTINE') {
    return '常规'
  } else if (cellValue === 'ASSEMBLE') {
    return '拼团'
  } else if (cellValue === 'SPIKE') {
    return '秒杀'
  } else if (cellValue === 'SUBSCRIPTION') {
    return '预约金'
  } else if (cellValue === 'FIRSTORDER') {
    return '首单'
  }
  return cellValue
}
function formatExpressStyle (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'BYSELF') {
    return '自提'
  } else if (cellValue === 'BYEXPRESS') {
    return '快递'
  }
  return cellValue
}
function formatOrderStatus (cellValue) {
  if (cellValue === 'UNUSERD') {
    return '已付款待使用'
  } else if (cellValue === 'PAY') {
    return '已付款未发货'
  } else if (cellValue === 'CREATE') {
    return '未付款'
  } else if (cellValue === 'SEND') {
    return '已发货待收货'
  } else if (cellValue === 'FINISHED') {
    return '交易完成'
  } else if (cellValue === 'CLOSED') {
    return '交易关闭'
  } else if (cellValue === 'ATTESTATIONFAIL') {
    return '验签失败'
  }
  return cellValue
}
function formatCouponStatus (cellValue) {
  if (!cellValue) {
    return '/'
  }
  if (cellValue === 'NO') {
    return '未生成'
  } else if (cellValue === 'YES') {
    return '已生成'
  }
  return cellValue
}

function formatCouponType (cellValue) {
  if (!cellValue) {
    return '/'
  }
  if (cellValue === 'DISCOUNT') {
    return '折扣'
  } else if (cellValue === 'REDUCTION') {
    return '满减'
  } else if (cellValue === 'DEDUCTION') {
    return '抵扣'
  }
  return cellValue
}

function formatYesOrNo (cellValue) {
  if (!cellValue) {
    return '/'
  }
  if (cellValue === 'YES') {
    return '是'
  } else if (cellValue === 'NO') {
    return '否'
  }
  return cellValue
}
function formatGoodsStyle (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'NORMAL') {
    return '普通商品'
  } else if (cellValue === 'POINT') {
    return '积分商品'
  }
  return cellValue
}
function formatComplaintType (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'YES') {
    return '已处理'
  } else if (cellValue === 'NO') {
    return '未处理'
  }
  return cellValue
}
function formatCode (cellValue) {
  if (cellValue === null) {
    return ''
  }
  return cellValue
}
function formatAssembleStatus (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'PROCESSING') {
    return '拼团中'
  } else if (cellValue === 'SUCCESS') {
    return '拼团成功'
  } else if (cellValue === 'FAILURE') {
    return '拼团失败'
  }
  return cellValue
}
function formatSeckillGoodsStartIcon (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'STARTED') {
    return 'FINISHED'
  } else if (cellValue === 'NOSTART') {
    return 'STARTED'
  }
  return cellValue
}
// 表单验证
// 金额
function validPrice (message) {
  let reg = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/
  return function (rule, value, callback) {
    if (!value) {
      callback(new Error('请输入内容'))
    } else if (!reg.test(value)) {
      callback(new Error(message))
    } else {
      callback()
    }
  }
}
// 正整数
function validInteger (message) {
  // let reg = /^\+?[1-9][0-9]*$/
  let reg = /^[1-9]\d*$/
  return function (rule, value, callback) {
    if (!value) {
      callback(new Error('请输入内容'))
    } else if (!reg.test(value)) {
      callback(new Error(message))
    } else {
      callback()
    }
  }
}
// 空字符串
function validStringEmpty (message) {
  return function (rule, value, callback) {
    if (!value) {
      callback(new Error('请输入内容'))
    } else if (!value.trim()) {
      callback(new Error(message))
    } else {
      callback()
    }
  }
}
function formatBarginStatus (cellValue) {
  if (cellValue === 'BARGIN_PROCESS') {
    return '砍价中'
  } else if (cellValue === 'BARGIN_SUCCESS') {
    return '砍价成功'
  } else if (cellValue === 'BARGIN_FAILURE') {
    return '砍价失败'
  }
  return cellValue
}
function formatBindStatus (cellValue) {
  if (cellValue === 'YES') {
    return '已绑定'
  } else if (cellValue === 'NO') {
    return '未绑定'
  }
  return cellValue
}
function formatBackOrderStatus (cellValue) {
  if (cellValue === 'REFUND_REVIEW') {
    return '退款审核中'
  } else if (cellValue === 'REFUESED') {
    return '拒绝退款申请'
  } else if (cellValue === 'CLOSED') {
    return '退单成功'
  }
  return cellValue
}
function formatBindHandleStatus (cellValue) {
  if (cellValue === 'DEALED') {
    return '已处理'
  } else if (cellValue === 'APPLIED') {
    return '未处理'
  }
  return cellValue
}
function formatOfflineAudit (value) {
  if (value === 'PASS') {
    return '已审核'
  } else if (value === 'UNREVIEWWED') {
    return '未审核'
  }
}
function formatOfflineSignIn (value) {
  if (value === 'ARRIVE') {
    return '已签到'
  } else if (value === 'NONARRIVAL') {
    return '未签到'
  }
}
function formatSeckillGoodsStatus (cellValue) {
  if (cellValue === 'NOSTART') {
    return '未开始'
  } else if (cellValue === 'STARTED') {
    return '进行中'
  } else if (cellValue === 'FINISHED') {
    return '已结束'
  }
  return cellValue
}
function formatLotteryStatus (cellValue) {
  if (cellValue === 'READY') {
    return '未开始'
  } else if (cellValue === 'ACTING') {
    return '进行中'
  } else if (cellValue === 'OVER') {
    return '已结束'
  }
  return cellValue
}
function formatGoodsStatus (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'NOSTART') {
    return '开始'
  } else if (cellValue === 'STARTED') {
    return '结束'
  }
  return cellValue
}
function formatGoodsStatusIcon (cellValue) {
  if (cellValue === null) {
    return '/'
  }
  if (cellValue === 'NOSTART') {
    return 'iconfont icon-qiyongicon'
  } else if (cellValue === 'STARTED') {
    return 'iconfont icon-tingyongicon'
  }
  return cellValue
}
function formatReceiveAwardStatus (cellValue) {
  if (cellValue === 'NOT_ACCEPT') {
    return '未领奖'
  } else if (cellValue === 'ACCEPT') {
    return '已领奖'
  }
  return cellValue
}
function feeType (cellValue) {
  return {ORDINARY: '普通挂号', SPECIALIST: '专家挂号'}[cellValue]
}
function yesNo (cellValue, isreverse) {
  let arr = ['启用', '禁用']
  if (isreverse) arr.reverse()
  return {'YES': arr[0], 'NO': arr[1]}[cellValue]
}
function feeIcon (cellValue) {
  return {'YES': 'iconfont icon-xiaxian', 'NO': 'iconfont icon-shangxian'}[cellValue]
}
function statusType (cellValue) {
  return {'UNPAID': '未付款', 'PAID': '已付款', 'CANCELED': '已取消'}[cellValue]
}
function statusUseType (cellValue) {
  return {'USED': '已就诊', 'UNUSED': '未就诊'}[cellValue]
}
function methodSharing (val) {
  return {'FRIENDS': '转发给朋友', 'CIRCLEOFFRIENDS': '发送朋友圈', 'POSTER': '海报'}[val]
}
function activeState (val) {
  return {'NOTSTARTED': '未开始', 'STARTED': '进行中', 'FINISHED': '已结束'}[val] || ''
}
function formatIsEmployees (cellValue) {
  if (!cellValue) {
    return '/'
  }
  if (cellValue === 'YES') {
    return '员工'
  } else if (cellValue === 'NO') {
    return '用户'
  }
  return cellValue
}
function formatProject ({openTime, delFlag}) {
  const date = new Date().getTime()
  if (delFlag === 'YES') {
    return '已删除'
  } else if (openTime) {
    if ((openTime + '').length === 10) {
      openTime = openTime * 1000
    }
    return date > +openTime ? '已上线' : '未上线'
  } else {
    return '未上线'
  }
}
function formatCouponProject ({couponIsShow, delFlag}) {
  if (delFlag === 'YES') {
    return '已删除'
  } else if (couponIsShow) {
    if (couponIsShow === 'YES') {
      return '已上线'
    } else if (couponIsShow === 'NO') {
      return '未上线'
    }
  }
}
export default{
  validPrice,
  validInteger,
  validStringEmpty,
  formatDate,
  formatDateTime,
  formatSex,
  formatIsOnline,
  formatOnlineText,
  formatOnlineIcon,
  formatIsTop,
  formatTopText,
  formatStartText,
  formatStartIcon,
  formatChangeStatus,
  formatPriceType,
  formatBuyType,
  formatExpressStyle,
  formatOrderStatus,
  formatCouponStatus,
  formatCouponType,
  formatYesOrNo,
  formatAccountType,
  formatIntegralType,
  formatGoodsStyle,
  formatComplaintType,
  formatCode,
  formatAssembleStatus,
  formatBarginStatus,
  formatBindStatus,
  formatBackOrderStatus,
  formatBindHandleStatus,
  formatOfflineAudit,
  formatOfflineSignIn,
  formatSeckillGoodsStartIcon,
  formatSeckillGoodsStatus,
  formatLotteryStatus,
  formatGoodsStatus,
  formatGoodsStatusIcon,
  formatReceiveAwardStatus,
  feeType,
  yesNo,
  feeIcon,
  statusType,
  statusUseType,
  methodSharing,
  formatIsEmployees,
  activeState,
  formatProject,
  formatCouponProject,
  formatChangeDateAndriodIos
}



// WEBPACK FOOTER //
// ./src/assets/js/formatter.js